"use client";

import React from "react";
import { AppMainLayout } from "@/ui/layout/AppMainLayout";

export const AppPageLayout: React.FC<React.PropsWithChildren> = ({
  children
}) => {
  return (
    <div className="isolate flex h-screen flex-col">
      <AppMainLayout>{children}</AppMainLayout>
    </div>
  );
};
